// import React, { useState, useEffect, useRef } from 'react';
// import { FaRobot, FaTimes, FaPaperPlane, FaComments } from 'react-icons/fa';
// import axios from 'axios';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// const AIChat = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [inputMessage, setInputMessage] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const [sessionId, setSessionId] = useState('');
//   const messagesEndRef = useRef(null);

//   useEffect(() => {
//     // Generate or retrieve session ID
//     let sid = localStorage.getItem('chat_session_id');
//     if (!sid) {
//       sid = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
//       localStorage.setItem('chat_session_id', sid);
//     }
//     setSessionId(sid);

//     // Add welcome message
//     if (messages.length === 0) {
//       setMessages([
//         {
//           type: 'bot',
//           text: "Hi! I'm Vlinkin's AI Assistant 👋\n\nI can help you with:\n• Information about our training programs\n• Course details and technologies\n• Enrollment process\n• Placement assistance\n• Any other questions!\n\nHow can I assist you today?",
//           timestamp: new Date()
//         }
//       ]);
//     }
//   }, []);

//   useEffect(() => {
//     scrollToBottom();
//   }, [messages]);

//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   };

//   const handleSendMessage = async () => {
//     if (!inputMessage.trim() || isLoading) return;

//     const userMessage = {
//       type: 'user',
//       text: inputMessage,
//       timestamp: new Date()
//     };

//     setMessages(prev => [...prev, userMessage]);
//     setInputMessage('');
//     setIsLoading(true);

//     try {
//       const response = await axios.post(`${BACKEND_URL}/api/chat`, {
//         session_id: sessionId,
//         message: inputMessage
//       });

//       const botMessage = {
//         type: 'bot',
//         text: response.data.response,
//         timestamp: new Date()
//       };

//       setMessages(prev => [...prev, botMessage]);
//     } catch (error) {
//       console.error('Chat error:', error);
//       const errorMessage = {
//         type: 'bot',
//         text: "I'm sorry, I'm having trouble connecting right now. Please try again or contact us directly.",
//         timestamp: new Date()
//       };
//       setMessages(prev => [...prev, errorMessage]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter' && !e.shiftKey) {
//       e.preventDefault();
//       handleSendMessage();
//     }
//   };

//   const quickQuestions = [
//     "Tell me about Super 50 Program",
//     "What technologies do you teach?",
//     "How can I enroll?",
//     "Tell me about placement assistance"
//   ];

//   return (
//     <>
//       {/* Chat Button */}
//       {!isOpen && (
//         <button
//           onClick={() => setIsOpen(true)}
//           className="fixed bottom-6 right-6 bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-300 z-50 flex items-center gap-2 group"
//           data-testid="ai-chat-button"
//         >
//           <FaComments className="text-2xl" />
//           <span className="hidden group-hover:inline-block pr-2 font-semibold">Chat with AI</span>
//         </button>
//       )}

//       {/* Chat Window */}
//       {isOpen && (
//         <div
//           className="fixed bottom-6 right-6 w-96 h-[600px] bg-white rounded-2xl shadow-2xl flex flex-col z-50 border-2 border-gray-200 overflow-hidden"
//           data-testid="ai-chat-window"
//         >
//           {/* Header */}
//           <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4 flex items-center justify-between rounded-t-2xl">
//             <div className="flex items-center gap-3">
//               <div className="bg-white/20 p-2 rounded-full">
//                 <FaRobot className="text-2xl" />
//               </div>
//               <div>
//                 <h3 className="font-bold text-lg">Vlinkin AI Assistant</h3>
//                 <p className="text-xs text-white/80">Always here to help</p>
//               </div>
//             </div>
//             <button
//               onClick={() => setIsOpen(false)}
//               className="hover:bg-white/20 p-2 rounded-full transition-colors"
//               data-testid="close-chat-button"
//             >
//               <FaTimes className="text-xl" />
//             </button>
//           </div>

//           {/* Messages Container */}
//           <div className="flex-1 overflow-y-auto p-4 space-y-4 bg-gradient-to-b from-gray-50 to-white">
//             {messages.map((message, index) => (
//               <div
//                 key={index}
//                 className={`flex ${message.type === 'user' ? 'justify-end' : 'justify-start'}`}
//               >
//                 <div
//                   className={`max-w-[80%] rounded-2xl p-4 ${
//                     message.type === 'user'
//                       ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-br-none'
//                       : 'bg-white border-2 border-gray-200 text-gray-800 rounded-bl-none shadow-md'
//                   }`}
//                   data-testid={`chat-message-${index}`}
//                 >
//                   <p className="text-sm whitespace-pre-wrap leading-relaxed">{message.text}</p>
//                   <p className={`text-xs mt-2 ${message.type === 'user' ? 'text-white/70' : 'text-gray-400'}`}>
//                     {message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
//                   </p>
//                 </div>
//               </div>
//             ))}

//             {isLoading && (
//               <div className="flex justify-start">
//                 <div className="bg-white border-2 border-gray-200 rounded-2xl rounded-bl-none p-4 shadow-md">
//                   <div className="flex gap-2">
//                     <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
//                     <div className="w-2 h-2 bg-purple-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
//                     <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div ref={messagesEndRef} />
//           </div>

//           {/* Quick Questions */}
//           {messages.length <= 1 && (
//             <div className="px-4 pb-2">
//               <p className="text-xs text-gray-500 mb-2">Quick questions:</p>
//               <div className="flex flex-wrap gap-2">
//                 {quickQuestions.map((question, index) => (
//                   <button
//                     key={index}
//                     onClick={() => {
//                       setInputMessage(question);
//                     }}
//                     className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 py-1.5 rounded-full transition-colors"
//                   >
//                     {question}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Input Area */}
//           <div className="p-4 bg-white border-t-2 border-gray-200">
//             <div className="flex gap-2">
//               <input
//                 type="text"
//                 value={inputMessage}
//                 onChange={(e) => setInputMessage(e.target.value)}
//                 onKeyPress={handleKeyPress}
//                 placeholder="Type your message..."
//                 className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 transition-colors"
//                 disabled={isLoading}
//                 data-testid="chat-input"
//               />
//               <button
//                 onClick={handleSendMessage}
//                 disabled={!inputMessage.trim() || isLoading}
//                 className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-3 rounded-xl hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-2"
//                 data-testid="send-message-button"
//               >
//                 <FaPaperPlane />
//               </button>
//             </div>
//             <p className="text-xs text-gray-400 mt-2 text-center">Vlinkin AI Assistant • Powered by GPT-5.2</p>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default AIChat;
import React, { useState, useEffect, useRef } from "react";
import {
  FaRobot,
  FaTimes,
  FaPaperPlane,
  FaComments,
} from "react-icons/fa";
import axios from "axios";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  "https://linkinprofessionals.com/back_up/wp-json/vlinkin/v1";

const AIChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const messagesEndRef = useRef(null);

  useEffect(() => {
    let sid = localStorage.getItem("chat_session_id");

    if (!sid) {
      sid = `session_${Date.now()}_${Math.random()
        .toString(36)
        .substring(2, 12)}`;
      localStorage.setItem("chat_session_id", sid);
    }

    setSessionId(sid);

    setMessages([
      {
        type: "bot",
        text: `Hi! I'm Vlinkin's AI Assistant 👋

I can help you with:
• Training Programs
• Technologies & Courses
• Enrollment Process
• Placement Assistance
• Career Guidance

How can I assist you today?`,
        timestamp: new Date(),
      },
    ]);
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, [messages, isLoading]);

  const handleSendMessage = async (customMessage = "") => {
    const messageText = customMessage || inputMessage;

    if (!messageText.trim() || isLoading) return;

    const userMessage = {
      type: "user",
      text: messageText,
      timestamp: new Date(),
    };

    setMessages((prev) => [...prev, userMessage]);
    setInputMessage("");
    setIsLoading(true);

    try {
      // Correct API URL
      const apiUrl = `${BACKEND_URL}/chat`;

      console.log("Sending to:", apiUrl);

      const response = await axios.post(
        apiUrl,
        {
          session_id: sessionId,
          message: messageText,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const botMessage = {
        type: "bot",
        text:
          response.data?.response ||
          response.data?.message ||
          "No response received from server.",
        timestamp: new Date(),
      };

      setMessages((prev) => [...prev, botMessage]);
    } catch (error) {
      console.error("AI Chat Error:", error);

      let errorMessage = "Unable to connect to AI Assistant.";

      if (error.response?.status === 404) {
        errorMessage =
          "API endpoint not found. Please verify your WordPress REST API route.";
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      setMessages((prev) => [
        ...prev,
        {
          type: "bot",
          text: errorMessage,
          timestamp: new Date(),
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const quickQuestions = [
    "Tell me about Super 50 Program",
    "What technologies do you teach?",
    "How can I enroll?",
    "Tell me about placement assistance",
  ];

  return (
    <>
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-6 right-6 bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-all duration-300 z-50"
        >
          <FaComments className="text-2xl" />
        </button>
      )}

      {isOpen && (
        <div className="fixed bottom-6 right-6 w-96 h-[650px] bg-white rounded-2xl shadow-2xl border flex flex-col overflow-hidden z-50">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4 flex justify-between items-center">
            <div className="flex items-center gap-3">
              <FaRobot className="text-2xl" />
              <div>
                <h3 className="font-bold">Vlinkin AI Assistant</h3>
                <p className="text-xs opacity-90">
                  Online • Ready to Help
                </p>
              </div>
            </div>

            <button onClick={() => setIsOpen(false)}>
              <FaTimes />
            </button>
          </div>

          {/* Messages */}
          <div className="flex-1 overflow-y-auto p-4 bg-gray-50 space-y-4">
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`flex ${
                  msg.type === "user"
                    ? "justify-end"
                    : "justify-start"
                }`}
              >
                <div
                  className={`max-w-[80%] px-4 py-3 rounded-2xl shadow text-sm ${
                    msg.type === "user"
                      ? "bg-blue-600 text-white rounded-br-none"
                      : "bg-white text-gray-800 border rounded-bl-none"
                  }`}
                >
                  <div style={{ whiteSpace: "pre-wrap" }}>
                    {msg.text}
                  </div>

                  <div className="text-[10px] mt-2 opacity-70 text-right">
                    {new Date(msg.timestamp).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </div>
                </div>
              </div>
            ))}

            {isLoading && (
              <div className="flex justify-start">
                <div className="bg-white border px-4 py-3 rounded-2xl shadow text-sm text-gray-500">
                  Typing...
                </div>
              </div>
            )}

            <div ref={messagesEndRef} />
          </div>

          {/* Quick Questions */}
          {messages.length === 1 && (
            <div className="p-3 border-t bg-white">
              <div className="flex flex-wrap gap-2">
                {quickQuestions.map((question, index) => (
                  <button
                    key={index}
                    onClick={() => handleSendMessage(question)}
                    className="text-xs px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-full"
                  >
                    {question}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Input */}
          <div className="border-t p-3 bg-white flex gap-2">
            <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Type your message..."
              disabled={isLoading}
              className="flex-1 border rounded-xl px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-blue-500"
            />

            <button
              onClick={() => handleSendMessage()}
              disabled={!inputMessage.trim() || isLoading}
              className="bg-blue-600 hover:bg-blue-700 text-white px-5 rounded-xl disabled:opacity-50"
            >
              <FaPaperPlane />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AIChat;